<style lang="less" scoped>
.zlkTabsList{position: relative;margin-left: -36px;margin-top: 20px;}
ul{list-style: none;}
</style>

<template>
  <div class="zlkTabsList">
    <ul>
      <li v-for="(item,index) in List" :key="index">
        <TabsList class="tabsList" :tabsList="item" @getmore="goTo" @clickTabsList="goDetails"></TabsList>
      </li>
    </ul>
  </div>
</template>

<script>
/**
 * 何宽 资料库首页第一级分类内容页面
 */
import TabsList from '../assembly/TabsList.vue'
export default {
  components: {
    TabsList
  },
  name: '',
  data()
  {
    return {
      List: []
    }
  },
  // 初始化，将catid设置为0
  created()
  {
    this.$router.push({path: '/ZlkTabsList', query: {catid: 0}})
  },
  watch:
  {
    $route:
    {
      handler(nval, oval)
      {
        if (nval.query.catid)
          this.getCategory(+nval.query.catid)
      },
      immediate: true
    }
  },
  methods: {
    // 根据catid，从dmcn_values获取当前在页面展示的分类
    getCategory(num)
    {
      let paras = {cmd: 'query', _major: 99, _minor: 20, _exp: `moduleid=31 and glid=${num}`}
      window.post.getPost(paras).then((ret) =>
      {
        this.List = []
        ret.forEach(item => this.List.push({catid: item.id, type: item.dispc, button: '更多', content: []}))
        this.List.forEach(item =>
        {
          let paras = {cmd: 'query', _major: 99, _minor: 20, _exp: `moduleid=31 and glid=${item.catid}`}
          window.post.getPost(paras).then((cret) =>
          {
            cret.forEach((citem, cindex) =>
            {
              item.content.push({catid: citem.id, name: (cindex + 1).toString(), title: citem.dispc, listdata: []})
            })

            item.content.forEach(ccitem =>
            {
              // 根据catid，从dmcn_article_103获取当前需要展示的列表数据
              let paras = {cmd: 'query', _major: 11, _minor: 24, _exp: `catid=${ccitem.catid} and examine = 0`, orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 10}
              window.post.getPost(paras).then((ccret) =>
              {
                ccitem.listdata = ccret[0].data
              })
            })
          })
        })
      })
    },
    // 根据分类的不同层级，跳转到不同的页面，并将相应的条件提交到vuex
    goTo(obj)
    {
      let paras = {cmd: 'query', _major: 99, _minor: 20, _exp: 'moduleid=31'}
      window.post.getPost(paras).then((ret) =>
      {
        let temp = []
        ret.forEach(item =>
        {
          if (parseInt(item.glid) === obj.catid) temp.push(item)
        })
        let bool = ret.some(item =>
        {
          return temp[0].id === parseInt(item.glid)
        })

        if (bool === true)
        {
          let url = this.$router.resolve({path: '/ZlkTabsList1', query: {catid: obj.catid}})
          window.open(url.href, '_blank')
        }
        else
        {
          let url = this.$router.resolve({path: '/ZlkListDouble', query: {catid: obj.catid}})
          window.open(url.href, '_blank')
        }
      })
    },
    // 跳转到矿业资讯详情页面，并将被点击的对象的id提交到vuex
    goDetails(item)
    {
      let url = this.$router.resolve({path: '/ZlkDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/ZlkTabsList.vue